<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.OWNERSHIP_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x4 sp-store-details-general-ownership__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'STORES.OWNER_ID_LABEL'"
      [content]="store?.owner_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>

    <app-shared-info
      [label]="'STORES.OWNER_NAME_LABEL'"
      [content]="getOwnerName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'STORES.OWNER_EMAIL_LABEL'"
      [content]="store?.owner_email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
